import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconDownloadOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M22.72 11.3c.4.4.4 1.02 0 1.42l-5.94 5.94c-.18.22-.46.34-.76.34-.26 0-.52-.1-.72-.3l-6.02-6.02a.99.99 0 0 1 0-1.42.99.99 0 0 1 1.42 0l4.32 4.32V2c0-.56.44-1 1-1s1 .44 1 1v13.6l4.3-4.3a.99.99 0 0 1 1.42 0z" clipRule="evenodd" /><path fill="currentColor" d="M30 31H2c-1.1 0-2-.9-2-2V16c0-.56.44-1 1-1s1 .44 1 1v13h28V16c0-.56.44-1 1-1s1 .44 1 1v13c0 1.1-.9 2-2 2" /></svg>;
export default SvgIconDownloadOutlined;